import type { MovieItem } from "@/types/movie";

interface TrendingSeriesProps {
  items: MovieItem[];
}

export default function TrendingSeries({ items }: TrendingSeriesProps) {
  return (
    <section id="series" className="scroll-mt-16 border-y border-background-200 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-8xl px-4 md:px-8">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-sm font-medium text-accent-700">剧集热播</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              本周电视剧、动漫与综艺更新追踪
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-600">
            正在热播的剧集进度一目了然，古装、悬疑、谍战、热血新番与下饭综艺都在这里，跟着进度追更不迷路。
          </p>
        </div>

        <div className="mt-8 grid gap-4 md:grid-cols-2">
          {items.map((item) => (
            <article
              key={item.id}
              className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors duration-300 hover:border-primary-300 md:p-4"
            >
              <div className="relative h-32 w-24 shrink-0 overflow-hidden rounded-md bg-secondary-200 md:h-36 md:w-24">
                <img
                  src={item.poster}
                  alt={`${item.title} 海报`}
                  title={`${item.title} 剧集在线观看`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex min-w-0 flex-1 flex-col">
                <div className="flex items-start justify-between gap-2">
                  <h3 className="truncate text-base font-semibold text-foreground-950">{item.title}</h3>
                  <span className="flex shrink-0 items-center gap-1 text-sm font-bold text-accent-700">
                    <i className="ri-star-fill text-xs text-primary-500"></i>
                    {item.rating.toFixed(1)}
                  </span>
                </div>
                <div className="mt-1 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-600">
                  <span>{item.year}</span>
                  <span className="text-background-300">·</span>
                  <span>{item.genre}</span>
                  <span className="text-background-300">·</span>
                  <span>{item.region}</span>
                </div>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
                <div className="mt-auto flex items-center gap-2 pt-2">
                  <span className="rounded-full bg-primary-100 px-2.5 py-0.5 text-xs font-medium text-primary-800">
                    {item.meta}
                  </span>
                  <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-medium text-secondary-900">
                    {item.tag}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}